import type {RecommendedStory} from "./storyRecommendations";

// Retain the actual media elements so the cards use the already-buffered video.
// Cross-origin media loading works without changing the asset bucket's CORS policy.
const videos = new Map<string, HTMLVideoElement>();
const covers = new Set<string>();

export function getStoryVideoElement(story: RecommendedStory): HTMLVideoElement {
  const key = story.slug + ":" + story.videoMp4Url + ":mp4";
  const existing = videos.get(key);
  if (existing) return existing;
  const video = document.createElement("video");
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = "auto";
  video.poster = story.coverUrl;
  video.setAttribute("aria-hidden", "true");
  const source = document.createElement("source");
  source.src = story.videoMp4Url;
  source.type = "video/mp4";
  video.appendChild(source);
  videos.set(key, video);
  return video;
}

export function preloadStoryMedia(stories: RecommendedStory[]): void {
  const wanted = new Set(stories.map(story => story.slug));
  for (const [key, video] of videos) {
    if (!wanted.has(key.split(":")[0]) && !video.isConnected) {
      video.pause();
      video.replaceChildren();
      video.removeAttribute("src");
      video.load();
      videos.delete(key);
    }
  }
  for (const story of stories) {
    if (!covers.has(story.coverUrl)) {
      const image = new Image();
      image.src = story.coverUrl;
      covers.add(story.coverUrl);
    }
    const video = getStoryVideoElement(story);
    // Do not restart an existing preload when unrelated answers change.
    if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
  }
}
